module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Bold.08d37409.ttf";